// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b615f513","455":"96ae5c50"}[chunkId] + ".chunk.js";
};